var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M12.244 9.818v4.647h6.59c-.289 1.495-1.157 2.76-2.46 3.611l3.974 3.022C22.664 19.004 24 15.928 24 12.273c0-.851-.078-1.67-.223-2.455z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "m5.384 14.284-.897.672-3.173 2.422A12.27 12.27 0 0 0 12.246 24c3.306 0 6.078-1.07 8.104-2.902l-3.974-3.022c-1.091.72-2.483 1.157-4.13 1.157-3.184 0-5.889-2.106-6.857-4.942z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M1.314 6.622a11.66 11.66 0 0 0 0 10.756c0 .01 4.074-3.098 4.074-3.098a7 7 0 0 1-.39-2.28c0-.797.145-1.56.39-2.28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M12.246 4.778c1.804 0 3.407.611 4.687 1.79l3.506-3.437C18.313 1.189 15.554 0 12.247 0 7.46 0 3.33 2.695 1.314 6.622L5.39 9.72c.968-2.836 3.673-4.942 6.857-4.942"
  })));
};
export default SvgGoogle;